import { Component } from '@angular/core';

@Component({
  selector: 'app-no-record',
  template: `
    <div class="not-found text-center">
      <img src="assets/img/No-File-Found.png" class="mb-25 no-file-found" alt="not-found" />
      <h4 class="mb-15">{{ 'NORECORDSFOUND' | translate }}</h4>
      <p class="ms-auto me-auto">{{ 'NORECORDSDESCRIPTION' | translate }}</p>
    </div>
  `,
})
export class NoRecordComponent {}
